import { MapPin, TreePine, ShieldCheck, CheckCircle } from "lucide-react";
import { CashewLeaf, Farmer, ArecaNut } from "@/components/KonkanVectors";

const V = ({ children, className }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">{children}</div>
);

const FEATURES = [
  { icon: ShieldCheck, title: "Verified Owners", desc: "Trusted & verified homestay owners" },
  { icon: MapPin, title: "Local Support", desc: "Assistance before, during & after your stay" },
  { icon: CheckCircle, title: "No Hidden Charges", desc: "Transparent pricing you can trust" },
  { icon: TreePine, title: "Authentic Experiences", desc: "Experience Konkan like a local" },
];

export const WhyBookSection = () => (
  <section className="relative py-12 md:py-14 px-6 md:px-8 bg-[#FAF8F3] border-y border-border/20 overflow-hidden" data-testid="features-section">
    <V className="left-2 md:left-6 top-0 w-20 md:w-32 opacity-[0.18]"><CashewLeaf /></V>
    <V className="right-0 md:right-6 bottom-0 w-28 md:w-40 opacity-[0.18]"><Farmer /></V>
    <V className="left-1/2 -translate-x-1/2 top-1 w-10 md:w-14 opacity-[0.12]"><ArecaNut /></V>
    <div className="max-w-7xl mx-auto relative z-10">
      <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-8">Why Book With Kokan Homestays?</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {FEATURES.map((f, i) => (
          <div key={i} className="flex items-start gap-3" data-testid={`feature-card-${i}`}>
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <f.icon className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-0.5">{f.title}</h3>
              <p className="text-xs text-muted-foreground leading-relaxed">{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
